import { Widget as WidgetActions } from '../constants';
import { Widget } from '../store/models';
import { IWidgetAction } from '../interfaces/actions';

export const addWidget = (widget: Widget): IWidgetAction => ({ 
    type: WidgetActions.ADD, 
    payload: { widget } 
});

export const deleteWidget = (widget: Widget): IWidgetAction => ({ 
    type: WidgetActions.DELETE, 
    payload: { widget } 
});

export const updateWidget = (widget: Widget): IWidgetAction => ({ 
    type: WidgetActions.UPDATE, 
    payload: { widget } 
});

export const updateWidgetSettings = (widgetId: string, settings): IWidgetAction => ({ 
    type: WidgetActions.UPDATE_SETTINGS, 
    payload: { widgetId, settings } 
});

export const updateWidgets = (widgets: Widget[]): IWidgetAction => ({ 
    type: WidgetActions.UPDATE_ALL, 
    payload: { widgets }
});


// WEBPACK FOOTER //
// ./src/actions/Widget.ts